import React from 'react'
import { useAppSelector } from '@SonarCX/hooks/redux'
import { Skeleton } from '@mui/material'

import CardColumn from '@SonarCX/components/atoms/CardColumn'
import Card from '@SonarCX/components/atoms/Card'
import StatusDot from '../InboxesColumns/StatusDot'
import OnlineProfile from '../InboxesColumns/OnlineProfile'
import UserOverride from '../InboxesColumns/UserOverrride'
import TeamRestrict from '../InboxesColumns/TeamRestrict'
import EditDelete from '../InboxesColumns/EditDelete'

import { selectBaseInbox } from '@SonarCX/slices/baseInbox'
import useStyles from './styles'

type InboxesCardsProps = {
  openModal: (data: APIBaseInbox) => () => void
}

const InboxesCards: React.FC<InboxesCardsProps> = ({ openModal }) => {
  const { loaded, inboxes } = useAppSelector(selectBaseInbox)

  const classes = useStyles()

  return (
    <CardColumn className={classes.root}>
      {!loaded && (
        <Card style={{ padding: '0' }}>
          <Skeleton variant='rounded' style={{ height: '100px' }} />
        </Card>
      )}

      {loaded && inboxes.length === 0 && (
        <Card>
          <div className={classes.noData}>No inboxes</div>
        </Card>
      )}

      {inboxes.map(inbox => (
        <Card key={inbox.id}>
          <div className={classes.dataRow}>
            <StatusDot className={classes.dot} />

            <div className={classes.name}>{inbox.name}</div>

            <EditDelete open={openModal} data={inbox} />
          </div>

          <div className={classes.dataRow}>
            <div>Profile</div>

            <OnlineProfile profile={inbox.online_profile} />
          </div>

          <div className={classes.dataRow}>
            <div>User Override</div>

            <UserOverride override={inbox.user_override} />
          </div>

          <div className={classes.dataRow}>
            <div>Restriction</div>

            <TeamRestrict
              allTeams={inbox.all_teams}
              teamRestrict={inbox.team_restrict}
            />
          </div>
        </Card>
      ))}
    </CardColumn>
  )
}

export default InboxesCards
